import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { BrComponent } from '@bloomreach/react-sdk';
import { generateConditionalClassNames, removeWhiteSpaceChars } from '../utils/utils.js';

var CmsRow = ({ component  })=>{
    const _ref = component.getParameters(), { showInDesktop , showInTablet , showInPhone , fullWidth , tabButtonTitle  } = _ref, cssStyles = swcHelpers.objectWithoutProperties(_ref, [
        "showInDesktop",
        "showInTablet",
        "showInPhone",
        "fullWidth",
        "tabButtonTitle"
    ]);
    const filteredStyles = Object.fromEntries(Object.entries(cssStyles).filter(([_, value])=>value !== ''
    ));
    const rowClassName = generateConditionalClassNames('br-row', {
        fullWidth,
        showInDesktop,
        showInTablet,
        showInPhone
    });
    const idValue = tabButtonTitle ? removeWhiteSpaceChars(`rowTabPanel-${tabButtonTitle}`) : undefined;
    const ariaLabelledByValue = tabButtonTitle ? removeWhiteSpaceChars(`rowTabButton-${tabButtonTitle}`) : undefined;
    return /*#__PURE__*/ React.createElement("div", swcHelpers.extends({
        className: rowClassName,
        "data-t": "br-row",
        style: swcHelpers.objectSpread({}, filteredStyles)
    }, idValue && {
        id: idValue
    }, ariaLabelledByValue && {
        'aria-labelledby': ariaLabelledByValue
    }), /*#__PURE__*/ React.createElement(BrComponent, null));
};

export { CmsRow, CmsRow as default };
//# sourceMappingURL=Row.js.map
